export const IS_DEV = process.env.NODE_ENV !== "production";
export const NEXT_PUBLIC_MAIN_API_URL: string =
  process.env.NEXT_PUBLIC_MAIN_API_URL || "$NEXT_PUBLIC_MAIN_API_URL";
export const NEXT_PUBLIC_UPLOAD_URL: string =
  process.env.NEXT_PUBLIC_UPLOAD_URL || "$NEXT_PUBLIC_UPLOAD_URL";
export const NEXT_PUBLIC_NUTRITION_LINK_URL: string =
  process.env.NEXT_PUBLIC_NUTRITION_LINK_URL ||
  "$NEXT_PUBLIC_NUTRITION_LINK_URL";
export const AUTH_SECRET: string = process.env.AUTH_SECRET || "$AUTH_SECRET";

// log
export const LOGER_URL: string = process.env.LOGER_URL || "$LOGER_URL";
export const LOGER_SECRET: string = process.env.LOGER_SECRET || "$LOGER_SECRET";
export const APPLICATION_ID: string =
  process.env.APPLICATION_ID || "$APPLICATION_ID";
